import { InboundOrderDetailPage } from "@/features/inbound-order/pages/InboundOrderDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inbound-order/$orderId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { orderId } = Route.useParams();
	return <InboundOrderDetailPage orderId={orderId} />;
}
